module.exports = __webpack_public_path__ + "static/image3-46e0d6c9ad6bb12cc7a646b647dcee85.jpg";